// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-registration-form{width:350px}`, "",{"version":3,"sources":["webpack://./src/modals/CreateRegistrationForm/style.scss"],"names":[],"mappings":"AACA,0BACE,WAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
